import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue';
import nyirBilar from '@/components/nyirbilar.vue'


const routes = [
  {
    path: '/nyirbilar',
    name: 'nyirBilar',
    component: nyirBilar,
    props: route => ({ page: 'New' }), // Pass the variable here
  },
  {
    path: '/',
    name: 'bilar',
    component: nyirBilar,
    props: route => ({ page: 'New' }), // Pass the variable here
  },
  {
    path: '/gamlirbilar',
    name: 'gamlirBilar',
    component: nyirBilar,
    props: route => ({ page: 'Old' }), // Pass the variable here
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
